import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import TableSkeleton from "../../components/skeleton/table";
import ReportsTable from "./components/table";
import toast from "react-hot-toast";
import api from "../../services/api";

const Reports = () => {
  const [activeTab, setActiveTab] = useState("TEACHER");
  const [loading, setLoading] = useState({});
  const [tabData, setTabData] = useState({
    TEACHER: null,
    STUDENT: null,
  });

  const setApiLoading = (key, value) => {
    setLoading((prev) => ({ ...prev, [key]: value }));
  };

  const fetchReportsData = async (tabKey) => {
    if (tabData[tabKey]) return; // already fetched

    setApiLoading(tabKey, true);
    try {
      let response;
      if (activeTab === "TEACHER") {
        response = await api.get(
          "/students/reports"
        );
      } else {
        response = await api.get(
          "/teachers/reports"
        );
      }
      setTabData((prev) => ({
        ...prev,
        [tabKey]: response?.data?.data,
      }));
    } catch (error) {
      console.error(`Error fetching ${tabKey} data:`, error);
    } finally {
      setApiLoading(tabKey, false);
    }
  };

  useEffect(() => {
    fetchReportsData(activeTab);
  }, [activeTab]);

  // TEACHER = students have reported teachers
  // STUDENTS = teachers have reported students
  const handleResolve = async (reportedUserId, reportId, resolved) => {
    console.log(resolved);
    // debugger;
    try {
      if (activeTab === "TEACHER") {
        await api.put(
          `/students/${reportedUserId}/reports/${reportId}`,
          { isResolved: resolved }
        );
      } else {
        await api.put(
          `/teachers/${reportedUserId}/reports/${reportId}`,
          { isResolved: resolved }
        );
      }
      toast.success("Issue resolved!");
    } catch (error) {
      console.log(error);
      toast.error("Something wen wrong while updating issue!");
    }
  };

  const handleBlock = async (id, isBlocked) => {
    try {
      const requestBody = { isBlocked: !isBlocked };
      if (activeTab === "TEACHER") {
        // block student
        await api.put(
          `/students/${id}/toggleBlock`,
          requestBody
        );
        toast.success(
          `Student ${!isBlocked ? "blocked" : "unblocked"} successfully.`
        );
      } else {
        // block teacher
        await api.put(
          `/teachers/${id}/toggleBlock`,
          requestBody
        );
        toast.success(
          `Teacher ${!isBlocked ? "blocked" : "unblocked"} successfully.`
        );
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong!");
    }
  };

  const renderContent = () => {
    const isLoading = loading[activeTab];
    const data = tabData[activeTab] || [];

    if (isLoading) return <TableSkeleton columns={5} rows={4} />;
    return (
      <div style={{ height: "400px", width: "100%", overflow: "hidden" }}>
        <ReportsTable
          reportsData={data}
          tab={activeTab}
          onResolve={handleResolve} // RESOLVE function
          onBlock={handleBlock}
        />
      </div>
    );
  };

  return (
    <Layout>
      <div className="container mt-4 overflow-hidden">
        <div className="row text-start mb-2">
          <h3 className="h3">Reports</h3>
        </div>
        <div className="mt-2 col-sm-12 col-md-12 col-lg-12 mx-auto shadow border rounded py-2 overflow-hidden">
          <ul className="nav nav-tabs mb-3">
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "TEACHER" ? "active" : ""
                }`}
                onClick={() => setActiveTab("TEACHER")}
              >
                Teachers
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "STUDENT" ? "active" : ""
                }`}
                onClick={() => setActiveTab("STUDENT")}
              >
                Students
              </button>
            </li>
          </ul>

          <div className="tab-content">
            <div className="table-responsive">{renderContent()}</div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Reports;
